module.exports = __webpack_public_path__ + "static/media/icon_survey2.6e37256b.svg";